import type { ButtonHTMLAttributes } from "react";
import { StatusIcon } from "./statusIcon.tsx";
import styles from "./closeButton.module.scss";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Label shown next to the X. Omit for icon-only. */
  label?: string;
}

/**
 * Modal/dialog close button — outlined, with a crisp inline SVG X.
 * Replaces the "✕ Close" text buttons scattered across pages so they look consistent.
 */
export function CloseButton({ label = "Close", className, ...rest }: Props) {
  const cls = [styles.closeBtn, className].filter(Boolean).join(" ");
  return (
    <button type="button" aria-label={label} className={cls} {...rest}>
      <StatusIcon kind="close" size={14} className={styles.icon} />
      {label && <span>{label}</span>}
    </button>
  );
}
